var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    { staticClass: "lesson-detail-notes gap-4" },
    [
      _c(
        "v-list-item-avatar",
        [_c("v-icon", [_vm._v(_vm._s(_vm.hold ? "notes" : "assignment_ind"))])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list-item-content",
        [
          _c("v-list-item-subtitle", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n            " + _vm._s(_vm.content) + "\n        "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }